import { render, staticRenderFns } from "./Torules.vue?vue&type=template&id=51316372&scoped=true"
import script from "./Torules.vue?vue&type=script&lang=js"
export * from "./Torules.vue?vue&type=script&lang=js"
import style0 from "./Torules.vue?vue&type=style&index=0&id=51316372&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51316372",
  null
  
)

export default component.exports